import styled, { css } from "styled-components";
import { DividerProps } from "./types";

/**
 * Estilo do Divider
 * Configurações dinâmicas baseadas nas props fornecidas.
 */
export const StyledDivider = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["direction", "thickness", "color", "styleType"].includes(prop),
})<DividerProps>`
  ${({ direction = "horizontal", thickness, color, styleType, theme }) => css`
    border-color: ${color || theme.colors.lightGray};
    border-style: ${styleType};

    ${
      direction === "horizontal"
        ? css`
          width: 100%;
          border-bottom-width: ${thickness || theme.spacing(0.35)};
        `
        : css`
          height: 100%;
          border-left-width: ${thickness || theme.spacing(0.5)};
        `
    }
  `}
`;
